import React from 'react'
import {
  ArticleHeader,
  Border,
  Copy,
  SectionFull,
  AsideList,
  Sidebar,
  CardNews
} from '@website2018/da-dobsonville'
import Media from 'react-media'
import ArticleFooter from './ArticleFooter'
import NoSSR from '../Nav/NoSSR'
import { Link } from 'react-router-dom'
import { dateRegex } from '../../common/utils'
const Article = props => {
  const { post: p, news } = props

  return [
    <SectionFull mt={'medium'}>
      <div className={'col-lg-8'}>
        <ArticleHeader
          subHeading={
            p.province && p.province.length ? `${p.province.map(p => p.name).join(' | ')}` : null
          }
          title={p.title.rendered}
          attribution={
            p.meta && p.meta.person && p.meta.person.hasMember
              ? `Issued by ${p.meta.person.member} – ${p.meta.person.role}`
              : null
          }
          meta={
            p.category && p.category.length
              ? `${p.formattedDate} in ${p.category[0].name}`
              : `${p.formattedDate}`
          }
        />

        <article className="entry">
          <Copy intro html={p.content.rendered} />
        </article>

        <Media query="(min-width: 576px)">
          {matches =>
            matches ? <Border mt={'large'} mb={'large'} /> : <Border mt={'small'} mb={'medium'} />
          }
        </Media>

        <NoSSR>
          <ArticleFooter p={p} />
        </NoSSR>
      </div>

      <Sidebar col="col-lg-3 ml-auto">
        <AsideList title={'Latest News'}>
          {news
            .filter(n => n.id !== p.id)
            .map(p => {
              const [, year, month] = dateRegex.exec(p.date)
              const imageUrl = p.featured_media
                ? ((p.featured_media.media_details
                      && p.featured_media.media_details.sizes
                      && p.featured_media.media_details.sizes.medium)
                  ? p.featured_media.media_details.sizes.medium.source_url
                  : p.featured_media.source_url)
                : null
              return (
                <Link to={`/${year}/${month}/${p.slug}`} key={p.id}>
                  <Media
                    query="(max-width: 767px)"
                    render={() => (
                      <CardNews
                        imageUrl={imageUrl}
                        title={p.title.rendered}
                        meta={
                          p.category.length
                            ? `${p.formattedDate} in ${p.category[0].name}`
                            : `${p.formattedDate}`
                        }
                      />
                    )}
                  />
                  <Media
                    query="(min-width: 768px) and (max-width: 992px)"
                    render={() => (
                      <CardNews
                        imageUrl={imageUrl}
                        title={p.title.rendered}
                        meta={
                          p.category.length
                            ? `${p.formattedDate} in ${p.category[0].name}`
                            : `${p.formattedDate}`
                        }
                      />
                    )}
                  />
                  <Media
                    query="(min-width: 993px)"
                    render={() => (
                      <CardNews
                        vertical
                        imageUrl={imageUrl}
                        title={p.title.rendered}
                        meta={
                          p.category.length
                            ? `${p.formattedDate} in ${p.category[0].name}`
                            : `${p.formattedDate}`
                        }
                      />
                    )}
                  />
                </Link>
              )
            })}
        </AsideList>
      </Sidebar>
    </SectionFull>
  ]
}

export default Article
